// extracted by mini-css-extract-plugin
export default {"imageViewer":"ImageViewer_imageViewer__xMKSM","image":"ImageViewer_image__upc+A"};